import { setInteractionMode, localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';

import '@/core/validations';
import '@/core/payment-card/validations';

setInteractionMode('lazy');

localize({ en });
